var base = require('../../spark/settings/settings');
var subscriptions = require('../../spark/mixins/subscriptions')
var tabNav = require('./../../app/components/tab-navigation.vue');

Vue.component('spark-settings', {
    mixins: [base, tabNav, subscriptions],

    data () {
        return {
            activeTab: null
        }
    },

    computed: {
		restrictAccess() {
			if(this.spark.isGroupUser) return false;

			return (this.needsSubscription
				&& !this.subscriptionIsOnTrial
				&& !this.onGenericTrial);
		}
    },

    mounted() {
    	if(this.restrictAccess) {
    		this.activeTab = 'subscription';
    	}
    },

    watch: {
        activeTab(hash) {
            $('[href="#'+hash+'"]').click();
        }
    },
});
